import { useApp } from 'contexts/app';
import { useHistory } from 'react-router-dom';
import { Button, Paper, Stack, Text } from 'shell/components';

const InstantStudentFeedback = ({ assignment }) => {
    const { studentAccountUsers, feedback: allFeedback } = useApp();
    const history = useHistory();

    const feedback = allFeedback?.filter(({ owner_account_id }) => {
        return studentAccountUsers.some((student) => student.owner_account_id === owner_account_id);
    });

    const handleClick = () => {
        history.push(`/assignments/${assignment.id}/feedback`);
    };

    return (
        <Paper variant={'outlined'}>
            <Stack alignItems={'flex-start'} spacing={2}>
                <Text variant={'p1'}>Instant Student Feedback</Text>
                <Text color={'light'}>
                    You can review and edit feedback your students have generated for their assignment drafts here.
                </Text>
                <Button disabled={!feedback?.length} variant={'borderless'} onClick={handleClick}>
                    View Feedback
                </Button>
            </Stack>
        </Paper>
    );
};

export default InstantStudentFeedback;
